import { urlConfig } from "../config/urlConfig";
import CryptoJS from "crypto-js";
import { TemplateModel, UsersAccountsModel } from "../types/CommonModel";
import { postCall } from "./httpService";
import { appSettings } from "../config/appSetting";

const userAccountUrl = urlConfig.GetUsersAccounts;
const templateUrl = urlConfig.GetTemplate;

export const getCustomerData = async (usersAccountModel: UsersAccountsModel) => {
  try {
    const response = await postCall(userAccountUrl, usersAccountModel);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getTemplateData = async (templateModel: TemplateModel) => {
  try {
    const response = await postCall(templateUrl, templateModel);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const GetAccountByUser = async (params: any) => {
  try {
    const response = await postCall(urlConfig.AccountByUser, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};


export const GetActiveFileLocation = async (params: any) => {
  try {
    const response = await postCall(urlConfig.ActiveFileLocation, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
}

export const GetMetadataColumns = async (params: any) => {
  try {
    const response = await postCall(urlConfig.MetadataColumns, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
}

export const GetFolders = async (params: any) => {
  try {
    const response = await postCall(urlConfig.Folders, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
}

export const DecryptPassword = (encryptedPassword: string) => {
  try {
    let key = CryptoJS.enc.Utf8.parse(appSettings.AesKey);
    let iv = CryptoJS.enc.Utf8.parse(appSettings.AesIv);
    let decryptedPassword = CryptoJS.AES.decrypt(encryptedPassword, key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    return decryptedPassword.toString(CryptoJS.enc.Utf8);
  }
  catch (err) {
    return "";
  }
}

export const EncryptPassword = async (password: string) => {
  try {
    let key = CryptoJS.enc.Utf8.parse(appSettings.AesKey);
    let iv = CryptoJS.enc.Utf8.parse(appSettings.AesIv);
    let encryptedPassword = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(password), key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    return encryptedPassword.toString();
  }
  catch (err) {
    return "";
  }
}